import {Component, inject, OnInit, signal} from '@angular/core';
import {initFlowbite} from 'flowbite';
import {AppStore} from './shared/store/app.store';
import {RouterOutlet} from '@angular/router';
import {Alert} from './shared/components/alert/alert';
import {EventService} from './shared/services/event.service';
import {PostHogService} from './shared/services/posthog.service';
import {environment} from '../environments/environment';
import {LoadingService} from './shared/services/loading.service';
import {LoadingOverlay} from './shared/components/loading-overlay/loading-overlay';
import {ResultsStore} from './shared/store/results.store';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    Alert,
    LoadingOverlay
  ],
  templateUrl: './app.html',
  styleUrl: './app.css',
  standalone: true
})
export class App implements OnInit{
  protected readonly title = signal('tire-finder');

  appStore = inject(AppStore)
  loading = inject(LoadingService)

  private eventService = inject(EventService)
  private posthogService = inject(PostHogService)
  private resultsStore = inject(ResultsStore)

  constructor() {
    // Watched here rather than per page, a search can start on lookup and finish on results
    this.loading.watch('Searching', this.resultsStore.isSearchPending, this.resultsStore.searchSteps);
  }

  ngOnInit() {
    this.posthogService.init(environment.posthogKey, {
      api_host: environment.posthogHost,
      capture_exceptions: true,
    });
    initFlowbite();
    this.eventService.emit('init', {});
  }
}
